<template>
	<div class="layout-img">
		<slot name="title"></slot>
		<b-row>
			<template v-for="(item, index) in dataList">
				<b-col class="layout-item" :key="index" :cols="cols" :md="md">
					<!-- 普通样式 -->
					<b-row v-if="type == 'normal'">
						<!-- 图片 -->
						<router-link :to="'/donors/detail?id=' + item.id">
							<div
								class="img-wrap img-hovor"
							>
								<img
									width="100%"
									height="100%"
									:src="item.titleUrl"
								/>
							</div>
							<div>
								<p style="text-align: center; color: #666666">
									{{ item.donorName }}
								</p>
								<p v-if="$i18n.locale == 'cn'" style="text-align: center; color: #999999">
									{{ item.donorEnName }}
								</p>
							</div>
						</router-link>
					</b-row>
					<!-- 监督委员会样式 -->
					<b-row v-if="type == 'unnormal'"  class="mt-4" >
						<!-- 图片 -->
						<b-col cols="6" md="12">
							<router-link :to="'/donors/detail?id=' + item.id">
								<div class="img-wrap img-hovor">
									<img
										width="100%"
										height="100%"
										:src="item.photoUrl"
									/>
								</div>
							</router-link>
						</b-col>
						<!-- 文字 -->
						<b-col class="person-text pl-5 pr-5 " cols="6" md="12">
							<div class="name">
								<h2>{{ item.donorName }}</h2>
							</div>
							<ul
								v-if="item.rank"
								class="rank-text"
								style="line-height: 1.6rem;min-height: 11rem;overflow: hidden;"
							>
								<li
									v-for="(subitem, ind) in item.rank.split(
										'，'
									)"
									:key="ind"
								>
									{{ subitem }}
								</li>
							</ul>
						</b-col>
					</b-row>
				</b-col>
			</template>
		</b-row>
	</div>
</template>
<script>
export default {
	props: {
		md: Number,
		cols: Number,
		dataList: {
			type: Array,
			default: () => [
				// {
				//     name: '获奖人',
				//     ename: 'huojiangren',
				//     type: '生命科学奖',
				//     year: 2021,
				//     donorName: 'A'
				// },
			],
		},
		type: {
			type: String,
			default: 'normal',
		},
	},
	data() {
		return {}
	},
	watch: {
		dataList(val) {
			this.dataList = val
		},
	},
	methods: {},
}
</script>
<style lang="scss" scoped>
.rank-text li {
	list-style: initial !important;
	color: #999999;
	font-size: 1rem;
}
.person-text {
	.name {
		color: #666666;
		text-align: center;
		font-size: 1.2rem;
	}
}
.layout-img {
	a {
		text-decoration: none;
		cursor: pointer;
		.img-wrap {
			width: 70%;
		}
	}
}
@media (max-width: 768px) {
	.rank-text {
		height: 11rem;
		overflow: hidden;
	}
	
	.layout-img {
		a {
			text-decoration: none;
			cursor: pointer;
			.img-wrap {
				width: 70%;
			}
		}
	}

	.person-text {
        padding-top: 2.2rem;
        padding-left: 0 !important;
		.name {
			text-align: left;
		}
	}
	
}
</style>
